import {init as initLogin} from './../trackers/customer/login-tracker';
import {init as initPassword} from './../trackers/customer/lost-password-tracker';

export const init = () => {
  // Initialisation des trackers
  if($('body').hasClass('login-page')) initLogin();
  if ($('#main-container #lost-password').length > 0 || $('#main-container #resetPasswordForm').length > 0) initPassword();

  // Init Shopping tools

  // Init Enhanced e-Commerce

};



// WEBPACK FOOTER //
// ./src/analytics/routes/authentification.anly.route.js